import { useMemo } from 'react';

import _ from 'lodash';

import { devicesStateService } from '../../../../services/devicesState.service';
import { createApiSlice } from '../../utils/createApiSlice';

const getCurrentDeviceStateSlice = createApiSlice({
  reducerPath: ['devices', 'state', 'getCurrentDeviceState'],
  apiFunction: devicesStateService.getCurrentStateV2,
  getStateUpdatePath: (action) => {
    const growerId = _.get(action, 'payload.apiArguments.0');
    const seasonId = _.get(action, 'payload.apiArguments.1');
    const deviceId = _.get(action, 'payload.apiArguments.2');
    return [growerId, seasonId, deviceId];
  },
  getSelectorPath: (growerId, seasonId, deviceId) => {
    return [growerId, seasonId, deviceId];
  },
  apiArgumentsFn: ({ growerId, seasonId, deviceId }) => [
    growerId,
    seasonId,
    deviceId
  ]
});

const { actions, selectors, useApiSelectors } = getCurrentDeviceStateSlice;

export const getCurrentDeviceStateActions = actions;

export const getCurrentDeviceStateSelectors = {
  ...selectors
};

export const useGetCurrentDeviceStateSelectors = (
  growerId,
  seasonId,
  deviceId
) => {
  const {
    inProgress,
    errorMessage,
    success,
    response: state,
    updatedAt
  } = useApiSelectors(growerId, seasonId, deviceId);

  return useMemo(
    () => ({
      state,
      inProgress,
      errorMessage,
      success,
      updatedAt
    }),
    [errorMessage, inProgress, state, success, updatedAt]
  );
};

export default getCurrentDeviceStateSlice;
